import * as React from 'react';
import styled from '@emotion/styled';
import SEO from '../components/seo';
import { Section, SectionContent } from '../components/utility/section';

const PrivacyPolicyPage = () => (
  <>
    <SEO title="Privacy Policy" />
    <Section>
      <PrivacySectionContent>
        <h1>Launchcode Privacy Policy</h1>

        <p>
          When you visit Launchcode’s website, certain information may be shared with us to serve
          you better. This privacy policy ("policy") will help you understand how Launchcode ("us",
          "we", "our") uses and protects the data you provide to us when you visit and use
          www.lc.dev ("website", "service").
        </p>

        <p>
          We reserve the right to change this policy at any given time. If you want to make sure
          that you are up to date with the latest changes, we advise you to frequently visit this
          page.
        </p>

        <h2>What Information We Collect</h2>

        <p>When you visit the website, we may collect the following data:</p>

        <ul>
          <li>Your IP address.</li>
          <li>Your contact information and email address.</li>
          <li>Other information such as interests and preferences.</li>
          <li>Data profile regarding your online behavior on our website.</li>
        </ul>

        <h2>Why We Collect This Information</h2>

        <p>We are collecting your data for several reasons:</p>

        <ul>
          <li>To better understand your needs.</li>
          <li>To improve our services and products.</li>
          <li>
            To send you promotional emails containing the information we think you will find
            interesting.
          </li>
          <li>To respond to inquiries you might have.</li>
          <li>
            To customize our website according to your online behavior and personal preferences.
          </li>
        </ul>

        <h2>Safeguarding and Securing Data</h2>

        <p>
          Launchcode is committed to securing your data and keeping it confidential. Launchcode has
          made all reasonable attempts to prevent data theft, unauthorized access, and disclosure by
          following industry standards and selecting appropriate technologies, which help us
          safeguard the information we collect online.
        </p>

        <h2>How We Collect Data</h2>

        <p>
          We employ cookies and similar technologies, including single-pixel gifs, to record your
          visit and collect certain information concerning the use of our website.
        </p>

        <p>
          Once you agree to visit our website, you also agree to use the data it collects regarding
          your online behavior (analyze web traffic, web pages you spend the most time on, and
          websites you visit).
        </p>
        <p>
          The data we collect by using cookies, and related technologies, is used to customize our
          website to your needs. After we use the data for statistical analysis, the data is
          completely removed from our systems.
        </p>
        <p>
          We use third party web site analytics and advertising tools such as Google Analytics on
          our website that employs cookies to collect certain information concerning the use of our
          website. We may expand our use of these technologies to save additional data as new
          technologies are added to the website.
        </p>
        <p>
          If you want to disable cookies, you can do it by accessing the settings of your internet
          browser.
        </p>

        <h2>Links to Other Websites</h2>

        <p>
          Our website contains links that lead to other websites. If you click on these links
          Launchcode is not held responsible for your data and privacy protection. Visiting those
          websites is not governed by this privacy policy agreement. Make sure to read the privacy
          policy documentation of the website you go to from our website.
        </p>

        <h2>Restricting the Use of your Personal Data</h2>

        <p>
          Launchcode will not lease, sell or distribute personal information you provide to any
          third parties, unless we have your permission. We might do so if the law forces us. Your
          personal information may be used to personalize promotional content.
        </p>

        <p>
          If you would like to stop receiving marketing or emails that you have subscribed to, reply
          with unsubscribe or click on unsubscribe link at the bottom of our emails. Should you have
          any questions or concerns related to this privacy policy, please contact
          <a href="mailto:privacy@lc.dev" target="_blank" rel="noreferrer">
            privacy@lc.dev
          </a>
          .
        </p>
      </PrivacySectionContent>
    </Section>
  </>
);

const PrivacySectionContent = styled(SectionContent)`
  ul {
    font-size: 1.25rem;
  }

  a {
    color: var(--purple-color);
  }
`;

export default PrivacyPolicyPage;
